$(document).ready(function() {
  var $mainSlider = $('.product-main-slider');
  var $thumbnailSlider = $('.product-thumbnail-slider');
  if ($mainSlider.length && $thumbnailSlider.length) {
    $mainSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: '.product-thumbnail-slider',
      infinite:false
    });
    $thumbnailSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.product-main-slider',
      focusOnSelect: true,
      vertical:true,
      verticalSwiping:true
    });
  }

  var $videoButtonControl = $('[data-video-button-control]');
  if ($videoButtonControl.length) {
    $videoButtonControl.on('click', function () {
      const $button = $(this);
      const $video = $button.closest('.multi-collections-video-container').find('video');
      const $playIcon = $button.find('[data-play-video]');
      const $pauseIcon = $button.find('[data-pause-video]');

      if ($video.get(0).paused) {
        $video.get(0).play();
        $playIcon.addClass('hidden');
        $pauseIcon.removeClass('hidden');
        $videoButtonControl.attr('aria-label','Pause video');
        $videoButtonControl.attr('aria-pressed', 'true');
      } else {
        $video.get(0).pause();
        $pauseIcon.addClass('hidden');
        $playIcon.removeClass('hidden');
        $videoButtonControl.attr('aria-label','Continue video');
        $videoButtonControl.attr('aria-pressed', 'false');
      }

      $video.on('ended', function () {
        console.log('ended');
        $pauseIcon.addClass('hidden');
        $playIcon.removeClass('hidden');
        $videoButtonControl.attr('aria-label','Play video');
        $videoButtonControl.attr('aria-pressed', 'false');
      });
    });
  }

  document.addEventListener('rebuy.ready', function(event) {
    if ($('.rebuy-product-price').length > 0) {
      const rebuyPrices = $('.rebuy-product-grid .rebuy-product-block .rebuy-product-price .rebuy-money span');

      rebuyPrices.each(function () {
        let text = $(this).text();
        $(this).text(text.replace('.00', ''));
      });
    }
  });
});

// sections/accordian-panel.liquid
$(document).ready(function () {
  $(".accordian-panel > .accordian-heading").on("click", function () {
    const $panel = $(this).closest(".accordian-panel");
    const isActive = $panel.hasClass("active");

    if (isActive) {
      // If already active, remove active and slide up
      $panel.removeClass("active");
      $(this).siblings(".accordian-content").slideUp(200);
      $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      // Only open this panel, don't close others
      $panel.addClass("active");
      $(this).siblings(".accordian-content").slideDown(200);
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
    }
  });
});

